module.exports = __webpack_public_path__ + "angebot1.45a20395c5193ca5be471a78d0dcb7a6.png";